import i18n from 'i18next';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { capitalizeFirstLetter } from '../pages/attendee/detail/components/utils';

export default class ModerationAttendee extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true },
            cache: false,
            allow_cache: false
        };
    }

    static listUrl({ organizationId, flowId }) {
        if (!organizationId) {
            throw new Error('[Moderation Attendees] OrganizationId is mandatory');
        }
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/attendees`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/attendees`;
    }

    get _event() {
        if (!this.object.event_spam_moderation) return null;

        if (!this.__cached_event) {
            this.__cached_event = this.object.external_event;
        }
        return this.__cached_event;
    }

    get attendeeResolvedName() {
        if (this._event) {
            return this._event?.name;
        }
        if (this.object.attendee_last_name) {
            return `${this.object.attendee_last_name.toUpperCase()} ${capitalizeFirstLetter(this.object.attendee_first_name)}`;
        }
        return i18n.t('ticket.manager.nonNominative').toUpperCase();
    }

    get spamEvent() {
        return {
            id: this._event?.id,
            name: this._event?.name,
            status: this._event?.publication_status
        };
    }

    get spamOrga() {
        return {
            id: this._event?.organization_id,
            name: this._event?.organization_name
        };
    }

    get spamEventLink() {
        return `/ticket/O${this._event?.organization_id}/E${this._event?.id}/settings/event`;
    }

    get spamOrgaLink() {
        return `/ticket/O${this._event?.organization_id}`;
    }

    get spamEventMinisite() {
        return this._event?.gemino_url;
    }

    get spamEventWebsite() {
        return this._event?.website;
    }

    static triggerTransition(data, { organizationId, attendeeId, flow }) {
        const query = flow && flow.allow_removed_attendees ? '?include_removed=true' : '';

        let uri = `/ticket/organizations/${organizationId}/moderation_flows/attendees/${attendeeId}/trigger_transition${query}`;

        if (flow) {
            uri = `/ticket/organizations/${organizationId}/moderation_flows/${flow.id}/attendees/${attendeeId}/trigger_transition${query}`;
        }

        return fetcher.post(uri, {
            data: data
        });
    }

    static getNextAttendee({ organizationId, flowId, query, skip = false }) {
        if (!organizationId) {
            throw new Error('[ModerationAttendee] OrganizationId is mandatory');
        }
        const queryString = 'skip_current=1';
        let queryParams = query;

        if (skip) {
            queryParams = query ? query?.concat('&', queryString) : queryString;
        }

        return fetcher
            .get(`${this.listUrl({ organizationId, flowId })}/next`, {
                cache: false,
                allow_cache: false,
                query: queryParams?.replace('?', '')
            })
            .then(({ response: { id } }) => {
                if (!flowId) {
                    return { id, url: `/ticket/O${organizationId}/moderation/moderation_attendees/${id}${query}` };
                }
                return { id, url: `/ticket/O${organizationId}/moderation/moderation_flows/${flowId}/moderation_attendees/${id}${query}` };
            });
    }

    static unlock({ organizationId, flowId, lockId }) {
        if (!organizationId || !lockId) {
            throw new Error('[ModerationAttendee] OrganizationId and lockId are mandatory');
        }
        if (!flowId) {
            return fetcher.delete(`/ticket/organizations/${organizationId}/moderation_flows/locks/${lockId}`);
        }
        return fetcher.delete(`/ticket/organizations/${organizationId}/moderation_flows/${flowId}/locks/${lockId}`);
    }
}
